import React, { useState } from 'react';

import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

import {
  RootContainer,
  StyledTitle,
  AccordionContainer,
  AnswerContainer,
  StyledList,
} from './styles';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export function Accordion({ question, answers }) {
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <RootContainer>
      <AccordionContainer>
        <StyledTitle variant="h3">{question}</StyledTitle>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </AccordionContainer>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <AnswerContainer>
          {answers.map((answer) => {
            if (answer.type === 'list') {
              return (
                <StyledList component="ol">
                  {answer.items.map((item) => (
                    <ListItem
                      component="li"
                      sx={{ display: 'list-item', p: 0 }}
                    >
                      <ListItemText primary={item} />
                    </ListItem>
                  ))}
                </StyledList>
              );
            }

            return (
              <Typography sx={{ fontSize: '0.9rem' }} gutterBottom>
                {answer.content}
              </Typography>
            );
          })}
        </AnswerContainer>
      </Collapse>
    </RootContainer>
  );
}
